import React from "react";
import { Drawer, Box, Typography, Divider, Stack, Button } from "@mui/material";
import DocumentItem from "../../Components/Masters/DocumentItem";
import { put } from "../../utils/api";
import { getMonthName } from "../../utils/getMonthName";
import { head } from "lodash";

const ViewDeletedDrawer = ({
  open,
  onClose,
  data,
  headers,
  fetchDataCallback,
  apiUrl,
  setsnackOpen,
}) => {
  if (!data) return null;
  console.log("000", data);
  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
        deleted: true,
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response?.data?.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const lastEntry = data?.timeLine?.[data.timeLine.length - 1];

  const timestamp = new Date(lastEntry?.timeStamp);
  const formattedDate = timestamp.toLocaleDateString("en-IN");
  const formattedTime = timestamp.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const formatValue = (key, value) => {
    if (!value && value !== 0) return "—";
    if (key === "consumptionPeriod") {
      return value?.month && value?.year
        ? `${getMonthName(value.month)} ${value.year}`
        : "—";
    }

    if (key === "amountSpend") {
      return `${value.value} ${value.currency}`;
    }

    if (key === "distanceCovered") {
      return value?.value != null
        ? `${parseFloat(value.value).toFixed(4)} ${value.unit || ""}`
        : "-";
    }

    // console.log(value,"222")
    // if (key === "purchaseVendor") {
    //   return value?.purchase?.vendorLegalName || "-";
    // }

    if (key === "vendor" && typeof value === "object") {
      return value?.VendorLegalFullName || "—";
    }

    if (key === "equipment" && Array.isArray(value)) {
      const names = value.map((eq) => eq?.equipment).filter(Boolean); // remove undefined/null
      return names.length ? names.join(", ") : "—";
    }

    // If value is an array (generic handler)
    if (Array.isArray(value)) {
      return value.join(", ");
    }

    if (typeof value === "object") {
      if (value?.value !== undefined && value?.unit !== undefined) {
        return `${value.value} ${value.unit}`;
      }
      return (
        value?.vendorLegalName ||
        value?.name ||
        value?.industryProcess ||
        value?.equipment ||
        "—"
      );
    }

    return value;
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box width="30vw" maxWidth={800} p={3}>
        <Typography variant="h6" gutterBottom>
          Deleted Entry Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Stack spacing={2}>
          {headers?.map((header) => (
            <Box key={header.key}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {header.title}
              </Typography>
              <Typography>
                {formatValue(header.key, data[header.key])}
              </Typography>
            </Box>
          ))}

          {/* Add extra fields not part of headers but still required */}
          {data?.editRemarkReason && (
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
               Delete Remark Reason
              </Typography>
              <Typography>{data?.editRemarkReason}</Typography>
            </Box>
          )}
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Created By
            </Typography>
            <Typography>{lastEntry?.name || "—"}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Date
            </Typography>
            <Typography>{formattedDate}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Time
            </Typography>
            <Typography>{formattedTime}</Typography>
          </Box>

          {/* Documents */}
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Documents (optional)
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              {data?.documents?.length > 0 ? (
                <>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {data.documents
                      .filter((url) =>
                        ["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                      )
                      .map((url, index) => (
                        <DocumentItem key={`img-${index}`} url={url} />
                      ))}
                  </Box>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {data.documents
                      .filter(
                        (url) =>
                          !["png", "jpg", "jpeg"].includes(
                            url.split(".").pop().toLowerCase()
                          )
                      )
                      .map((url, index) => (
                        <DocumentItem key={`file-${index}`} url={url} />
                      ))}
                  </Box>
                </>
              ) : (
                <Typography>—</Typography>
              )}
            </Box>
          </Box>

          {/* Approve/Reject Actions */}
          <Stack direction="row" spacing={2} justifyContent="flex-start">
            <Button
              variant="contained"
              color="success"
              onClick={() => handleApprovalAction("approve")}
            >
              Approve
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => handleApprovalAction("reject")}
            >
              Reject
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default ViewDeletedDrawer;
